import { JsonObject } from 'json2typescript';
import { CodeTextDiscriminatorModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPerWorkSubareaTextModel')
export class PerWorkSubareaTextModel extends CodeTextDiscriminatorModel {}
